import { ResourceProps } from '@refinedev/core';
import {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  SafetyOutlined,
  CloudOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  ReadOutlined,
  FolderOutlined,
  FolderOpenOutlined,
  LikeOutlined,
  DollarOutlined,
  FieldTimeOutlined,
  FileProtectOutlined,
  FileOutlined,
  ImportOutlined,
  SafetyCertificateOutlined,
  TagOutlined,
  TagsOutlined,
  ShopOutlined,
  ApartmentOutlined,
  PictureOutlined,
  InteractionOutlined,
  BookOutlined,
  EditOutlined,
  SoundOutlined,
  SmileOutlined,
  OrderedListOutlined,
  TrophyOutlined,
  IdcardOutlined,
  ReconciliationOutlined,
  LineChartOutlined,
  AimOutlined,
  PartitionOutlined,
  WarningOutlined,
  PlayCircleOutlined,
  MobileOutlined,
  MessageOutlined,
  StarOutlined,
  CalculatorOutlined,
  PercentageOutlined,
  RetweetOutlined,
  FileDoneOutlined,
  BankOutlined,
  ToolOutlined,
  ThunderboltOutlined,
  HistoryOutlined,
  ClusterOutlined,
  AuditOutlined,
  HomeOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import { RevenueCatIcon } from '@/components/monetization/RevenueCatIcon';

/** Resource ``name`` values match Refine routes and admin API resource identifiers. */
export const resources: ResourceProps[] = [
  {
    name: 'dashboard',
    list: '/',
    meta: {
      icon: <DashboardOutlined />,
    },
  },
  {
    name: 'iam',
    meta: {
      icon: <TeamOutlined />,
    },
  },
  {
    name: 'iam.users',
    list: '/iam/users',
    show: '/iam/users/:id',
    meta: {
      parent: 'iam',
      icon: <UserOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'iam.oauth_accounts',
    list: '/iam/oauth_accounts',
    show: '/iam/oauth_accounts/:id',
    meta: {
      parent: 'iam',
      icon: <CloudOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'iam.oauth_clients',
    list: '/iam/oauth_clients',
    show: '/iam/oauth_clients/:id',
    meta: {
      parent: 'iam',
      icon: <AppstoreAddOutlined />,
    },
  },
  {
    name: 'iam.oauth_tokens',
    list: '/iam/oauth_tokens',
    show: '/iam/oauth_tokens/:id',
    meta: {
      parent: 'iam',
      icon: <SafetyOutlined />,
    },
  },
  {
    name: 'account',
    meta: {
      icon: <IdcardOutlined />,
    },
  },
  {
    name: 'account.profiles',
    list: '/account/profiles',
    show: '/account/profiles/:id',
    meta: {
      parent: 'account',
      icon: <ReconciliationOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'account.fcm_tokens',
    list: '/account/fcm_tokens',
    show: '/account/fcm_tokens/:id',
    meta: {
      parent: 'account',
      icon: <MobileOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'account.issued_licences',
    list: '/account/licences',
    meta: {
      parent: 'account',
      icon: <FileProtectOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'monetization',
    meta: {
      icon: <DollarOutlined />,
    },
  },
  {
    name: 'monetization.entitlements',
    list: '/monetization/entitlements',
    show: '/monetization/entitlements/:id',
    meta: {
      parent: 'monetization',
      icon: <FileProtectOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.customers',
    list: '/monetization/customers',
    show: '/monetization/customers/:id',
    meta: {
      parent: 'monetization',
      icon: <UserOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.products',
    list: '/monetization/products',
    show: '/monetization/products/:id',
    edit: '/monetization/products/:id/edit',
    meta: {
      parent: 'monetization',
      icon: <RevenueCatIcon width="1.2em" height="1.2em" fill="#f2545b" />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.revenuecat_subscriptions',
    list: '/monetization/revenuecat_subscriptions',
    show: '/monetization/revenuecat_subscriptions/:id',
    meta: {
      parent: 'monetization',
      icon: <RevenueCatIcon width="1.2em" height="1.2em" fill="#f2545b" />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.revenuecat_billing_periods',
    list: '/monetization/revenuecat_billing_periods',
    show: '/monetization/revenuecat_billing_periods/:id',
    meta: {
      parent: 'monetization',
      icon: <RevenueCatIcon width="1.2em" height="1.2em" fill="#f2545b" />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.revenuecat_events',
    list: '/monetization/revenuecat_events',
    show: '/monetization/revenuecat_events/:id',
    meta: {
      parent: 'monetization',
      icon: <RevenueCatIcon width="1.2em" height="1.2em" fill="#f2545b" />,
      canDelete: false,
    },
  },
  {
    name: 'monetization.withdrawal_contracts',
    list: '/monetization/withdrawal_contracts',
    show: '/monetization/withdrawal_contracts/:id',
    meta: {
      parent: 'monetization',
      icon: <SafetyCertificateOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'progress',
    meta: {
      icon: <FieldTimeOutlined />,
    },
  },
  {
    name: 'progress.progressions',
    list: '/progress/progressions',
    show: '/progress/progressions/:id',
    meta: {
      parent: 'progress',
      icon: <LineChartOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'progress.positions',
    list: '/progress/positions',
    show: '/progress/positions/:id',
    meta: {
      parent: 'progress',
      icon: <AimOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'progress.sessions',
    list: '/progress/sessions',
    show: '/progress/sessions/:id',
    meta: {
      parent: 'progress',
      icon: <PlayCircleOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'progress.segments',
    list: '/progress/segments',
    show: '/progress/segments/:id',
    meta: {
      parent: 'progress',
      icon: <PartitionOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'progress.segment_errors',
    list: '/progress/segment_errors',
    show: '/progress/segment_errors/:id',
    meta: {
      parent: 'progress',
      icon: <WarningOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'settlement',
    meta: {
      icon: <CalculatorOutlined />,
    },
  },
  {
    name: 'settlement.royalty_reports',
    list: '/settlement/royalty_reports',
    show: '/settlement/royalty_reports/:id',
    meta: {
      parent: 'settlement',
      icon: <FileDoneOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'settlement.cycles',
    list: '/settlement/cycles',
    show: '/settlement/cycles/:id',
    meta: {
      parent: 'settlement',
      icon: <RetweetOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'settlement.charges_monthly',
    list: '/settlement/charges_monthly',
    show: '/settlement/charges_monthly/:id',
    meta: {
      parent: 'settlement',
      icon: <FieldTimeOutlined />,
      canDelete: false,
    },
  },
  // No list route: the daily aggregate is only ever read through the daily tab
  // of a monthly charge, so it stays out of the menu.
  {
    name: 'settlement.charges_daily',
    meta: {
      parent: 'settlement',
      canDelete: false,
    },
  },
  {
    name: 'settlement.royalties_monthly',
    list: '/settlement/royalties_monthly',
    show: '/settlement/royalties_monthly/:id',
    meta: {
      parent: 'settlement',
      icon: <PercentageOutlined />,
      canDelete: false,
    },
  },
  // No list route: the daily aggregate is only ever read through the daily tab
  // of a monthly royalty, so it stays out of the menu.
  {
    name: 'settlement.royalties_daily',
    meta: {
      parent: 'settlement',
      canDelete: false,
    },
  },
  {
    name: 'user_catalog',
    meta: {
      icon: <ReadOutlined />,
    },
  },
  {
    name: 'user_catalog.home_page',
    list: '/user_catalog/home_page',
    meta: {
      parent: 'user_catalog',
      icon: <HomeOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'user_catalog.categories',
    list: '/user_catalog/categories',
    show: '/user_catalog/categories/:id',
    create: '/user_catalog/categories/create',
    edit: '/user_catalog/categories/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <FolderOpenOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.managed_collections',
    list: '/user_catalog/managed_collections',
    show: '/user_catalog/managed_collections/:id',
    create: '/user_catalog/managed_collections/create',
    edit: '/user_catalog/managed_collections/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <AppstoreAddOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.rankings',
    list: '/user_catalog/rankings',
    show: '/user_catalog/rankings/:id',
    create: '/user_catalog/rankings/create',
    edit: '/user_catalog/rankings/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <TrophyOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.series',
    list: '/user_catalog/series',
    show: '/user_catalog/series/:id',
    create: '/user_catalog/series/create',
    edit: '/user_catalog/series/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <OrderedListOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.publications',
    list: '/user_catalog/publications',
    show: '/user_catalog/publications/:id',
    edit: '/user_catalog/publications/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <BookOutlined />,
      canDelete: true,
    },
  },
  // Nested under publications: the sider gives a parent that has its own list
  // a first "all publications" child, so the list link survives the SubMenu.
  {
    name: 'user_catalog.publication_premieres',
    list: '/user_catalog/publication_premieres',
    show: '/user_catalog/publication_premieres/:id',
    meta: {
      parent: 'user_catalog.publications',
      icon: <RocketOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'user_catalog.authors',
    list: '/user_catalog/authors',
    show: '/user_catalog/authors/:id',
    create: '/user_catalog/authors/create',
    edit: '/user_catalog/authors/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <EditOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.lectors',
    list: '/user_catalog/lectors',
    show: '/user_catalog/lectors/:id',
    create: '/user_catalog/lectors/create',
    edit: '/user_catalog/lectors/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <SoundOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.publishers',
    list: '/user_catalog/publishers',
    show: '/user_catalog/publishers/:id',
    create: '/user_catalog/publishers/create',
    edit: '/user_catalog/publishers/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <ShopOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.tags',
    list: '/user_catalog/tags',
    show: '/user_catalog/tags/:id',
    create: '/user_catalog/tags/create',
    edit: '/user_catalog/tags/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <TagOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.emotions',
    list: '/user_catalog/emotions',
    show: '/user_catalog/emotions/:id',
    create: '/user_catalog/emotions/create',
    edit: '/user_catalog/emotions/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <SmileOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.banners',
    list: '/user_catalog/banners',
    show: '/user_catalog/banners/:id',
    create: '/user_catalog/banners/create',
    edit: '/user_catalog/banners/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <InteractionOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.banner_actions',
    list: '/user_catalog/banner_actions',
    show: '/user_catalog/banner_actions/:id',
    create: '/user_catalog/banner_actions/create',
    edit: '/user_catalog/banner_actions/:id/edit',
    meta: {
      parent: 'user_catalog',
      icon: <PictureOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'user_catalog.collections',
    list: '/user_catalog/collections',
    show: '/user_catalog/collections/:id',
    meta: {
      parent: 'user_catalog',
      icon: <AppstoreOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog',
    meta: {
      icon: <FolderOutlined />,
    },
  },
  {
    name: 'content_catalog.products',
    list: '/content_catalog/products',
    show: '/content_catalog/products/:id',
    meta: {
      parent: 'content_catalog',
      icon: <BookOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.publishers',
    list: '/content_catalog/publishers',
    show: '/content_catalog/publishers/:id',
    meta: {
      parent: 'content_catalog',
      icon: <ShopOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.imprints',
    list: '/content_catalog/imprints',
    show: '/content_catalog/imprints/:id',
    meta: {
      parent: 'content_catalog',
      icon: <ApartmentOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.distribution_periods',
    list: '/content_catalog/distribution_periods',
    show: '/content_catalog/distribution_periods/:id',
    meta: {
      parent: 'content_catalog',
      icon: <FieldTimeOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.thema_codes',
    list: '/content_catalog/thema_codes',
    meta: {
      parent: 'content_catalog',
      icon: <TagsOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.master_asset_files',
    list: '/content_catalog/master_asset_files',
    meta: {
      parent: 'content_catalog',
      icon: <FileOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'content_catalog.provider_imports',
    list: '/content_catalog/provider_imports',
    meta: {
      parent: 'content_catalog',
      icon: <ImportOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'feedback',
    meta: {
      icon: <LikeOutlined />,
    },
  },
  {
    name: 'feedback.reviews',
    list: '/feedback/reviews',
    show: '/feedback/reviews/:id',
    edit: '/feedback/reviews/:id/edit',
    meta: {
      parent: 'feedback',
      icon: <StarOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'feedback.testimonials',
    list: '/feedback/testimonials',
    show: '/feedback/testimonials/:id',
    create: '/feedback/testimonials/create',
    edit: '/feedback/testimonials/:id/edit',
    meta: {
      parent: 'feedback',
      icon: <MessageOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'tenancy',
    meta: {
      icon: <BankOutlined />,
    },
  },
  {
    name: 'tenancy.organizations',
    list: '/tenancy/organizations',
    show: '/tenancy/organizations/:id',
    create: '/tenancy/organizations/create',
    edit: '/tenancy/organizations/:id/edit',
    meta: {
      parent: 'tenancy',
      icon: <ClusterOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'tenancy.contracts',
    list: '/tenancy/contracts',
    show: '/tenancy/contracts/:id',
    create: '/tenancy/contracts/create',
    edit: '/tenancy/contracts/:id/edit',
    meta: {
      parent: 'tenancy',
      icon: <AuditOutlined />,
      canDelete: true,
    },
  },
  {
    name: 'system',
    meta: {
      icon: <ToolOutlined />,
    },
  },
  {
    name: 'system.activities',
    list: '/system/activities',
    show: '/system/activities/:id',
    meta: {
      parent: 'system',
      icon: <HistoryOutlined />,
      canDelete: false,
    },
  },
  {
    name: 'system.tools',
    list: '/system/tools',
    meta: {
      parent: 'system',
      icon: <ThunderboltOutlined />,
      canDelete: false,
    },
  },
];
